export const USERS_PER_PAGE = 100;
export const SEARCH_DEBOUNCE_MS = 300;
